import React from 'react';

import classNames from 'classnames';

import { formatPrice } from '@shared/helpers';

import cls from './BudgetInformationBlock.module.css';
import { useBudgetInformationBlock } from './useBudgetInformationBlock';
import {
    FinancialIndicatorsInfoElement,
    FinancialInfoType,
} from '../../../UI/FinancialIndicatorsInfoElement/FinancialIndicatorsInfoElement';

interface BudgetInformationBlockProps {
    classes?: string;
}

export const BudgetInformationBlock = ({ classes }: BudgetInformationBlockProps) => {
    const { financial_info } = useBudgetInformationBlock();
    return (
        <div className={classNames(cls.BudgetInformationBlock, [classes])}>
            <FinancialIndicatorsInfoElement
                title={i18next.t(
                    'BudgetInformationBlock.return.financialIndicatorsInfoElement.title'
                )}
                value={formatPrice(Math.round(financial_info.key_metrics.budget_saving), {
                    withCurrency: true,
                    currencySign: financial_info?.currency?.sign,
                })}
                positiveNumber={financial_info.key_metrics.budget_saving >= 0}
                negativeNumber={financial_info.key_metrics.budget_saving < 0}
                financialInfoType={FinancialInfoType.BUDGET_SAVED}
                tooltipText={i18next.t(
                    'BudgetInformationBlock.return.financialIndicatorsInfoElement.tooltipText'
                )}
            />
        </div>
    );
};
